import { Button } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const ButtonAction = ({ name, onClick, startIcon, type, endIcon }) => {
  return (
    <Box>
      <Button
        startIcon={startIcon}
        endIcon={endIcon}
        type={type}
        sx={{
          color: "primary.main",
          backgroundColor: "background.main",
          borderColor: "origin.main",
          "&:hover": { backgroundColor: "background.paper" },
        }}
        variant="outlined"
        onClick={onClick}
      >
        {name}
      </Button>
    </Box>
  );
};

export default ButtonAction;
